export const socketEventsHandlerDelays = {
  handleDoBetResult: 2500,
};
